export default __webpack_public_path__ + "static/media/1902.10bfaacc.png";